import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { AxiosPromise } from '../../../utils/axios.promise';
import { CommonConfig } from '../../../configs/config.common';
import VAccountingTimelineItem from '../../shared/VAccountingTimelineItem/v.accounting.timeline.item.vue';
import * as moment from 'moment';
const base64 = require('base-64');

@Component({
    components: {
        VAccountingTimelineItem
    },
})
export default class VAccountingVendorPage extends Vue {
    public configs = new CommonConfig();
    public orderDetail = null;
    public saleOrder = null;
    public client = null;
    public agent = null;
    public vendor = null;
    public orderCreatedDate: any = null;
    public orderDeliveryDate: any = null;
    public companyInvoices = null;
    public vendorInvoices = null;
    public clientInvoices = null;
    public orderDetailFetched = null;
    public sName = null;
    public showFixed2(val: number) {
        return Math.round(val * 100) / 100;
    }
    public async created() {
        const oid = this.$route.params.oid;
        this.sName = base64.decode(oid);
        const vendorApi = this.configs.vendorService;
        const url = `${vendorApi}/accounting/report?key=${oid}`;
        const fetched = await AxiosPromise.get(url);
        const detailUrl = `${vendorApi}/order/detail?sale_order_name=${oid}`;
        const orderDetailFetched = await AxiosPromise.get(detailUrl);
        if (fetched.code === 200 && orderDetailFetched) {
            this.orderDetail = fetched.data;
            this.orderDetailFetched = orderDetailFetched;
            this.orderCreatedDate = moment.utc(orderDetailFetched.overall.create_date).local().format('YYYY-MM-DD HH:mm');
            this.orderDeliveryDate = moment.utc(orderDetailFetched.overall.delivery_date).local().format('YYYY-MM-DD HH:mm');
            this.companyInvoices = fetched.data.statement.billBreakdowns.find((v: any) => {
                return v.key === 'MYCOMPANY';
            });
            this.vendorInvoices = fetched.data.statement.billBreakdowns.find((v: any) => {
                return v.key === 'VENDOR';
            });
            this.clientInvoices = fetched.data.statement.billBreakdowns.find((v: any) => {
                return v.key === 'CLIENT';
            });
        }
    }

    public async mounted() {

    }
}
